import template from './suburban-building-status.jade';
import validation from '../../../services/validation';
import suburbanBuildingStatus from '../../../enums/suburban-building-status-house';

export default angular
    .module('cian.addForm.suburbanBuildingStatus', [])
    .directive('cianAfAboutObjectSuburbanBuildingStatus', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: [function () {
            this.suburbanBuildingStatusOptions = suburbanBuildingStatus;

            this.validation = validation(this.form, 'suburbanBuildingStatus');
        }],
        controllerAs: 'suburbanBuildingStatus',
        template,
    }))
    .name;
